/* antd */
import { Form, Input, message } from 'antd';
/* React */
import React, { useCallback, useRef } from 'react';
import { AiFillApple } from 'react-icons/ai';
/* Icons */
import { FaFacebookF, FaGoogle } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';
import { Link } from 'react-router-dom';

/* Assets */
import Coruja from '../../assets/img/pet/corujaDedoLevantado.png';
import Footer from '../../components/Footer';
/* Components */
import { Header } from '../../components/Header';
/* Hooks */
import { useAuth } from '../../hooks/auth';
/* Interfaces */
import { SignInCredentials } from '../../interfaces/auth';
/* Styles */
import { Container, Content, FormWrapper, LoginOptions } from './styles';

interface LoginProps {}

const Login: React.FC<LoginProps> = () => {
  const {
    handleSignIn,
    SignInWithGoogle,
    SignInWithFacebook,
    SignInWithApple,
    loadingGoogle,
    setLoadingGoogle,
    loadingFacebook,
    setLoadingFacebook,
    loadingApple,
    setLoadingApple,
  } = useAuth();
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const handleSubmit = useCallback(
    async (data: SignInCredentials) => {
      try {
        await handleSignIn(data);
      } catch (err) {
        message.error('Falha no login');
        return;
      }
    },
    [handleSignIn]
  );

  return (
    <Container>
      <Header />
      <Content>
        <aside>
          <img src={Coruja} alt="Imagem de uma coruja" />
        </aside>

        <main>
          <h1>Entrar com:</h1>
          <LoginOptions>
            <button
              onClick={() => {
                SignInWithGoogle('login');
                setLoadingGoogle(true);
              }}
              disabled={loadingApple || loadingFacebook || loadingGoogle}
            >
              {loadingGoogle ? (
                <h1 className="spinner">
                  <ImSpinner2 />
                </h1>
              ) : (
                <h1>
                  <FaGoogle />
                </h1>
              )}
            </button>
            <button
              onClick={() => {
                SignInWithFacebook('login');
                setLoadingFacebook(true);
              }}
              disabled={loadingApple || loadingFacebook || loadingGoogle}
            >
              {loadingFacebook ? (
                <h1 className="spinner">
                  <ImSpinner2 />
                </h1>
              ) : (
                <h1>
                  <FaFacebookF />
                </h1>
              )}
            </button>
            <button
              onClick={() => {
                SignInWithApple('login');
                setLoadingApple(true);
              }}
              disabled={loadingApple || loadingFacebook || loadingGoogle}
            >
              {loadingApple ? (
                <h1 className="spinner">
                  <ImSpinner2 />
                </h1>
              ) : (
                <h1>
                  <AiFillApple size={'1.7rem'} />
                </h1>
              )}
            </button>
          </LoginOptions>
          <FormWrapper>
            <Form
              layout="vertical"
              onFinish={handleSubmit}
              form={form}
              ref={formRef}
              requiredMark={false}
            >
              <div>
                <label>E-mail</label>
                <Form.Item
                  name={['email']}
                  rules={[
                    {
                      required: true,
                      type: 'email',
                      message: 'Email do usuário é obrigatório!',
                    },
                  ]}
                >
                  <Input
                    bordered={false}
                    style={{
                      borderBottom: '1px solid black',
                      marginTop: '5px',
                      fontSize: '18px',
                      padding: '2px 5px 0 5px',
                    }}
                  />
                </Form.Item>

                <label>Senha</label>
                <Form.Item name={['password']}>
                  <Input.Password
                    bordered={false}
                    style={{
                      borderBottom: '1px solid black',
                      padding: '2px 5px 0 5px',
                      margin: 0,
                    }}
                  />
                </Form.Item>
              </div>
              <button
                disabled={loadingApple || loadingFacebook || loadingGoogle}
              >
                entrar
              </button>
            </Form>
          </FormWrapper>
          <section>
            <div>
              <p>
                Esqueceu a senha?
                <Link to="/recuperar-senha">
                  <span>recuperar</span>
                </Link>
              </p>
            </div>
            <div>
              <p>
                não tem uma conta?
                <Link to="/cadastrar">
                  <span>cadastre-se</span>
                </Link>
              </p>
            </div>
          </section>
        </main>
      </Content>
      <Footer />
    </Container>
  );
};

export default Login;
